import { CHART_BLUE, VERTICAL_OFFSET } from './chart-constants'
import type { DataPoint, TooltipData } from './chart-utils'

interface ColumnChartProps {
    columnWidth: number
    data: Record<string | number, DataPoint>
    height: number
    onHover: (show: boolean, tooltip: TooltipData | Record<string, never>) => void
}

export function ColumnChart({ columnWidth, data, height, onHover }: ColumnChartProps) {
    return (
        <svg>
            {Object.values(data).map((point, index) => {
                const { xVal, xCoord: x, yCoord: y, yVal } = point

                const tooltip: TooltipData = { xPos: x, xVal, yPos: y, yVal }

                return (
                    <rect
                        key={`${index}-${x}-${y}`}
                        height={height - y + VERTICAL_OFFSET}
                        width={columnWidth}
                        x={x}
                        y={y}
                        fill={CHART_BLUE}
                        opacity={0.5}
                        rx={2}
                        style={{ cursor: 'pointer', transition: 'opacity 300ms ease-in-out' }}
                        onMouseOver={() => onHover(true, tooltip)}
                        onMouseOut={() => onHover(false, {})}
                        onTouchStart={() => onHover(true, tooltip)}
                        onTouchEnd={() => onHover(false, {})}
                    />
                )
            })}
        </svg>
    )
}
